/**
 * DashboardStats Component
 *
 * Displays key metrics in stat cards
 */

import React from 'react';
import { StatisticCard } from '@/components/statisticCard';
import { IoDocumentText, IoStatsChart, IoTrendingUp } from 'react-icons/io5';
import { FaDollarSign } from 'react-icons/fa';
import { useQuoteStats } from '../hooks';
import { DateRangeType } from '../types';

interface DashboardStatsProps {
  dateRange?: DateRangeType;
  region?: number;
}

export const DashboardStats: React.FC<DashboardStatsProps> = ({
  dateRange = 'thisweek',
  region,
}) => {
  const { data: quoteStatsData } = useQuoteStats(dateRange, region);
  const totalQuotes = quoteStatsData?.overallStats?.current?.totalQuotes ?? 0;
  const activeQuotes = quoteStatsData?.overallStats?.current?.activeQuotes ?? 0;
  const conversionRate = quoteStatsData?.overallStats?.current?.conversionRate ?? 0;
  const totalRevenue = quoteStatsData?.overallStats?.current?.totalRevenue ?? 0;

  const totalQuotesChange = quoteStatsData?.overallStats?.comparison?.totalQuotesChange ?? 0;
  const activeQuotesChange = quoteStatsData?.overallStats?.comparison?.activeQuotesChange ?? 0;
  const conversionRateChange = quoteStatsData?.overallStats?.comparison?.conversionRateChange ?? 0;
  const revenueChange = quoteStatsData?.overallStats?.comparison?.revenueChange ?? 0;

  return (
    <div className="flex gap-4 overflow-x-auto">
      <StatisticCard
        title="Total Quotes"
        value={totalQuotes}
        trend={totalQuotesChange}
        icon={<IoDocumentText size={14} />}
        iconBgColor="#ef4444"
        className="min-w-[177px]"
      />

      <StatisticCard
        title="Active Quotes"
        value={activeQuotes}
        trend={activeQuotesChange}
        icon={<IoStatsChart size={14} />}
        iconBgColor="#ef4444"
        className="min-w-[177px]"
      />

      <StatisticCard
        title="Conversion Rate"
        value={conversionRate}
        suffix="%"
        trend={conversionRateChange}
        icon={<IoTrendingUp size={14} />}
        iconBgColor="#ef4444"
        className="min-w-[177px]"
      />

      <StatisticCard
        title="Total Revenue"
        value={totalRevenue}
        prefix="£"
        trend={revenueChange}
        icon={<FaDollarSign size={14} />}
        iconBgColor="#ef4444"
        className="min-w-[177px]"
      />
    </div>
  );
};

export default DashboardStats;
